import React from "react";
import PropTypes from "prop-types";
import SvgIcon from "@mui/material/SvgIcon";

export default function StarIconFilled(props) {
  return (
    <SvgIcon width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
      <path d="M5.66983 16.0688L6.82206 11.2403L3 7.99192L8.01277 7.55604L9.98229 3L11.9518 7.57688L16.9646 7.99192L13.1425 11.2403L14.2947 16.0688L9.98229 13.5079L5.66983 16.0688Z" fill={props.color}/>
    </SvgIcon>
  );
}

StarIconFilled.propTypes = {
  color: PropTypes.string
};